export default __webpack_public_path__ + "static/media/7.9db87c1c.png";